import { render, staticRenderFns } from "./Personalizzazioni.vue?vue&type=template&id=abacc6c4&"
import script from "./Personalizzazioni.vue?vue&type=script&lang=ts&"
export * from "./Personalizzazioni.vue?vue&type=script&lang=ts&"
import style0 from "./Personalizzazioni.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports